import React, { useRef, useState } from "react";
import { Row, Col } from "reactstrap";
import PropTypes from "prop-types";
import { showToast } from "../ToastNotification";
import { re_kyc_nomineeNotOptedThunk } from "../../slices/thunks";
import { useDispatch } from "react-redux";
import usePersistStoreData from "../Hooks/usePersistStoreData";

const iconMap = {
  download: "ri-folder-download-line",
  upload: "ri-upload-cloud-line",
};

const DocumentActionCard = ({
  text,
  iconType = "download",
  onClick,
  supportText,
  loading,
  fileType = "image",
  hasError
}) => {
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState("");
  const dispatch = useDispatch();
  const { userData } = usePersistStoreData();
  const token = userData?.token;
  const [previewUrl, setPreviewUrl] = useState("");

  const handleIconClick = () => {
    if (iconType === "upload") {
      fileInputRef.current.click(); // trigger file input
    } else if (typeof onClick === "function") {
      onClick(); // handle download or other actions
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes =
      fileType === "pdf"
        ? ["application/pdf"]
        : ["image/jpeg", "image/png", "image/jpg"];
    const maxSize = 2 * 1024 * 1024; // 2MB

    if (!allowedTypes.includes(file.type)) {
      showToast(
        fileType === "pdf"
          ? "Only PDF files are allowed."
          : "Only JPEG, JPG, and PNG files are allowed.",
        "error"
      );
      return;
    }

    if (file.size > maxSize) {
      showToast("File size must be less than 2MB.", "error");
      return;
    }

    setFileName(file.name);
    setPreviewUrl(URL.createObjectURL(file)); // <-- store preview URL

    if (typeof onClick === "function") {
      onClick(file);
    }
  };
  return (
    <div className={`card card-body px-0 text-center position-relative ${hasError ? "mb-0" :"mb-3"} `}>
      <Row className="m-0 p-0">
        <Col xxl={12}>
          <div className="d-flex flex-column align-items-center justify-content-center">
            <div
              className="d-flex align-items-center justify-content-center cursor-pointer"
              style={{
                width: previewUrl ? "100%" : "6.8vh",
                height: "6.8vh",
                borderRadius: previewUrl ? "6px" : "50%", // rectangle for image, circle for icon
                backgroundColor: previewUrl ? "#f0f0f0" : "#f8f9fa", // light grey for preview
                border: previewUrl ? "1px solid #ccc" : "none", // subtle border
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                overflow: "hidden", // so image stays inside the circle

              }}
              onClick={!previewUrl ? handleIconClick : undefined}
            >
              {previewUrl ? (
                fileType === "pdf" ? (
                  <>
                    <div
                      className="d-flex flex-column align-items-center justify-content-center"
                      style={{
                        width: "100%",
                        height: "6.8vh",
                        borderRadius: "6px",
                        backgroundColor: "#f0f0f0",
                        border: "1px solid #ccc",
                        position: "relative",
                      }}
                    >
                      <i
                        className="ri-file-pdf-2-fill text-danger"
                        style={{ fontSize: "30px" }}
                      />
                      {/* <span className="mt-1 text-truncate" style={{ maxWidth: "80%" }}>{fileName}</span> */}

                      {/* Cross icon */}
                      <i
                        className="ri-close-circle-fill text-danger position-absolute cursor-pointer fs-20"
                        style={{
                          top: "-7px",
                          right: "-3px",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setPreviewUrl("");
                          setFileName("");
                          if (fileInputRef.current)
                            fileInputRef.current.value = "";
                            if (typeof onClick === "function") onClick(null);
                        }}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <img
                      src={previewUrl}
                      alt="Preview"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                    {/* Cross icon same as before */}
                    <i
                      className="ri-close-circle-fill text-danger position-absolute cursor-pointer fs-20"
                      style={{
                        top: "-6px",
                        right: "11px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setPreviewUrl("");
                        setFileName("");
                        if (fileInputRef.current)
                          fileInputRef.current.value = "";
                          if (typeof onClick === "function") onClick(null);
                      }}
                    />
                  </>
                )
              ) : Array.isArray(iconType) ? (
                iconType.map((type, i) => (
                  <i
                    key={i}
                    className={`${iconMap[type]} text-primary mx-1`}
                    style={{ fontSize: "25px" }}
                  />
                ))
              ) : (
                <i
                  className={`${iconMap[iconType]} text-primary`}
                  style={{ fontSize: "30px" }}
                />
              )}
            </div>

            {/* File Input (hidden) */}
            {iconType === "upload" && (
              <input
                type="file"
                accept={
                  fileType === "pdf" ? "application/pdf" : ".png,.jpg,.jpeg"
                }
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            )}
            {fileName && (
              <p className="text-success fs-14 mt-2 mb-0">{fileName}</p>
            )}
            {!fileName && (
              <p className="mt-2 mb-0 fw-semibold text-dark fs-5">
                {loading ? "Downloading..." : text}
              </p>
            )}
            {supportText && (
              <p className="text-muted fs-14  mb-0">({supportText})</p>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default DocumentActionCard;
